module.exports = __webpack_public_path__ + "static/media/web_development_.b443ed26.png";